import styled from 'styled-components';
import { ContentContainer } from '../containers';
import { Slider } from '../Slider';
import { SectionTitle } from '../Title';
import { useEffect, useState } from 'react';
import COLORS from '../../colors';
import { MONTH_LOWERCASE, MONTH_PASCAL } from '../../constants';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { mapPascalMonthToLowercaseMonth } from '../../util';
import {
  setFibLibLoadingPercentage,
  setFibLibValue
} from '../../redux/features/calculated/calculatedSlice';

interface FibLibProps {
  months: MONTH_PASCAL[] | undefined;
  batchUpdateTotals: (month: MONTH_LOWERCASE, fiblibLoading: number) => void;
}

const StyledText = styled.div`
  width: 600px;
  position: relative;
  font-size: 16px;
  line-height: 24px;
  color: ${COLORS.NEUTRAL_500};
  text-align: left;
  display: inline-block;
`;

const FibLib = ({ months, batchUpdateTotals }: FibLibProps) => {
  const dispatch = useAppDispatch();
  const calculated = useAppSelector((state) => state.calculated);
  const [value, setValue] = useState(0);
  const [loading, setLoading] = useState(0);

  const handleSliderChange = (newValue: number) => {
    setValue(newValue);
    setLoading(newValue / 10);
  };

  const batchUpdateFibLibPercentages = (): void => {
    if (months) {
      for (const month of months) {
        const lowercaseMonth = mapPascalMonthToLowercaseMonth(month);

        batchUpdateTotals(lowercaseMonth, loading);
        dispatch(setFibLibValue({ fibLib: value, month: lowercaseMonth }));
        dispatch(
          setFibLibLoadingPercentage({
            fibLibLoadingPercentage: loading,
            month: lowercaseMonth
          })
        );
      }
    }
  };

  const setUpPageOnLoad = () => {
    if (months) {
      const lowercaseMonth = mapPascalMonthToLowercaseMonth(months[0]);
      const existingValue = calculated[lowercaseMonth].fiblib;
      const existingLoading = calculated[lowercaseMonth].fiblibLoading;

      setValue(existingValue);
      setLoading(existingLoading);
    }
  };

  useEffect(() => {
    setUpPageOnLoad();
  }, []);

  useEffect(() => {
    if (months) {
      batchUpdateFibLibPercentages();
    }
  }, [loading]);

  return (
    <ContentContainer>
      <SectionTitle title="FIB / LIB" loadingPercentage={loading} />
      <StyledText>
        Select audience percentage to run in premium break positioning.
      </StyledText>
      <Slider
        maximumValue={100}
        value={value}
        onChange={(_, value) => handleSliderChange(value as number)}
      />
    </ContentContainer>
  );
};

export default FibLib;
